export default {
  cognito: {
    USER_POOL_ID: 'us-east-1_5OUKEBqan',
    POOL_ARN:
      'arn:aws:cognito-idp:us-east-1:905418219406:userpool/us-east-1_5OUKEBqan',
    IDENTITY_POOL_ID: 'us-east-1:c3d5bfc6-6bc3-45e2-b8e2-946d50d616cb',
    APP_CLIENT_NAME: 'spire-iot-client-spa',
    APP_CLIENT_ID: '6dav32qddrmpqnbtenb80jj448',
    REGION: 'us-east-1'
  }
};



// WEBPACK FOOTER //
// ./config.js